<script lang="ts">
    import FeatherIcon from "svelte-feather-icon";
    import { Col, Row } from "sveltestrap";
    import { href } from "../../../../utils/Constant/Constant";
    import {grid,classId} from "../../../../store"
    import Link from "svelte-link";
    import Featured from "./Featured.svelte";
    import GridOptions from "./GridOptions.svelte";
    import ProductListFilter from "./ProductListFilter.svelte";
    // for grid layout view
    function handleSidebar(){
        grid.update(value => value = false)
        classId.update(value => value = 3)
    }
    // for list layout view
    function handleSidebarList(){
        grid.update(value => value = true)
    }

</script>
<Row class="m-b-10">
    <Col md="3" sm="2" class="products-total">
        <div class="square-product-setting d-inline-block">
            <Link class="icon-grid grid-layout-view" href={href} on:click={handleSidebar}>
                <FeatherIcon icon="grid" />
            </Link>
        </div>
        <div class="square-product-setting d-inline-block">
            <Link class="icon-grid m-0 list-layout-view" href={href} on:click={handleSidebarList}>
                <FeatherIcon icon="list" />
            </Link>
        </div>
        <ProductListFilter />
        <GridOptions />
    </Col>
    <Featured />
</Row>  
